import { render, staticRenderFns } from "./page81.vue?vue&type=template&id=10aba832&scoped=true&"
import script from "./page81.vue?vue&type=script&lang=js&"
export * from "./page81.vue?vue&type=script&lang=js&"
import style0 from "./page81.vue?vue&type=style&index=0&id=10aba832&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10aba832",
  null
  
)

export default component.exports